module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-LightItalic.000973b.woff";